import React from 'react';

import { Text } from '@betterment/samba-react';

import { BannerWrapper } from './BannerWrapper';

export const Pending401kBanner: React.FC = () => {
  return (
    <BannerWrapper>
      <Text as="p">A solo 401(k) plan conversion is awaiting client approval.</Text>
    </BannerWrapper>
  );
};
